module.exports = __webpack_public_path__ + "static/img/doudian.95933632.png";